import requests from "../util";
const { request } = requests;
const fetchAllBatchesForReview = (pageNum, pageSize) => {
  let params = { pageNum, pageSize };
  return request({
    url: "/api/v1/batch/listBatchesForReview",
    method: "get",
    params: params,
  });
};
const getAllSkusForReview = (batchId, reviewStatus) => {
  const params = reviewStatus ? { reviewStatus } : undefined;
  return request({
    url: `/api/v1/batch/getBatchForReview/${batchId}`,
    method: "get",
    params,
  });
};
const getSkusForReview = (batchId, skuId) => {
  return request({
    url: `/api/v1/sku/review/${skuId}`,
    method: "get",
    params: { batchId },
  });
};

const acceptSkuOnReview = (skuId) => {
  return request({
    url: `/api/v1/sku/review/acceptSkuOnReview/${skuId}`,
    method: "patch",
  });
};
const acceptFileOnReview = (payload) => {
  return request({
    url: `/api/v1/sku/review/acceptFileOnReview`,
    method: "patch",
    body: payload,
  });
};
const rejectFileOnReview = (payload) => {
  return request({
    url: `/api/v1/sku/review/rejectFileOnReview`,
    method: "patch",
    body: payload,
  });
};
const saveMarkingsOnFile = (payload) => {
  return request({
    url: `/api/v1/sku/review/saveMarkingsOnFile`,
    method: "patch",
    body: payload,
  });
};

const deleteMarkingOnFile = (payload) => {
  return request({
    url: `/api/v1/sku/review/deleteMarkingOnFile`,
    method: "patch",
    body: payload,
  });
};
const downloadDeliverable = (payload) => {
  return request({
    url: `/api/v1/batch/downloadDeliverable`,
    method: "post",
    body: payload,
  });
};
const reviewApi = {
  fetchAllBatchesForReview,
  getAllSkusForReview,
  getSkusForReview,
  acceptSkuOnReview,
  acceptFileOnReview,
  rejectFileOnReview,
  saveMarkingsOnFile,
  deleteMarkingOnFile,
  downloadDeliverable,
};
export default reviewApi;
